import Actions from "../consts";
import InitialState from "../intial.state";
import {
  getNextNode,
  searchTree,
  updatePropertyById,
  updateRowInTree,
} from "../helper/tree.helper";

export const course = (state: any = InitialState.course, action: any = {}) => {
  switch (action.type) {
    case Actions.UN_AUTHORISE:
      return { ...InitialState.course, translationGeneration: (state.translationGeneration || 0) + 1 };
    case Actions.LOAD_SPANISH_COURSE:
      if (action.generation !== state.translationGeneration) return state;
      return { ...state, spanishContentStatus: "loading" };
    case Actions.RECEIVE_SPANISH_COURSE:
      if (action.generation !== state.translationGeneration) return state;
      return {
        ...state,
        spanishContent: action.payload,
        spanishContentStatus: action.payload ? "ready" : "unavailable",
      };
    case Actions.SPANISH_COURSE_FAILED:
      if (action.generation !== state.translationGeneration) return state;
      return { ...state, spanishContent: null, spanishContentStatus: "error" };
    case Actions.GET_COURSE:
      const courseData = action.payload;
      const translationState = {
        spanishContent: null,
        spanishContentStatus: "idle",
        translationGeneration: (state.translationGeneration || 0) + 1,
      };
      if (courseData.lastseen) {
        const lastSeen = searchTree(courseData, courseData.lastseen);
        return {
          ...state,
          ...translationState,
          data: courseData,
          selectedSection: lastSeen,
          showCongrats: false,
        };
      }

      return {
        ...state,
        ...translationState,
        data: courseData,
        selectedSection: courseData,
        showCongrats: false,
      };
    case Actions.UPDATE_LAST_SEEN:
      return { ...state, data: action.payload };
    case Actions.GET_CERTIFICATES:
      return { ...state, certificates: action.payload };
    case Actions.SET_COURSE_SECTION:
      return { ...state, selectedSection: searchTree(state.data, action.payload.id) };

    case Actions.MARK_LESSON_FINISH:
      const updatedData = updatePropertyById(
        action.payload.id,
        state.data,
        "finish",
        true
      );
      return { ...state, data: updatedData };
    case Actions.GO_LAST_SEEN:
      if (state.data.lastSeen) {
        const lastSeen = searchTree(state.data, state.data.lastSeen);
        return { ...state, selectedSection: lastSeen };
      }
      return state;
    case Actions.NEXT_LESSON:
      const lastSeen = getNextNode(
        state.data,
        state.selectedSection.id,
        state.data
      );
      return { ...state, selectedSection: lastSeen };
    case Actions.SUBMIT_QUIZ:
      const wasCourseFinished = Boolean(state.data?.finish);
      const updatedCourseData = updateRowInTree(state.data, action.payload.id, {
        ...state.selectedSection,
        ...action.payload,
      });
      const updatedSelected = searchTree(
        updatedCourseData,
        action.payload.lastseen
      );
      if (!wasCourseFinished && updatedCourseData.finish === true)
        return {
          ...state,
          data: updatedCourseData,
          selectedSection: updatedSelected,
          showCongrats: true,
        };
      else
        return {
          ...state,
          data: updatedCourseData,
          selectedSection: updatedSelected,
        };

    case Actions.HIDE_CONGRATS:
      return {
        ...state,
        showCongrats: false,
      };
    case Actions.RETRY_QUIZ:
      const retriedCourseData = updateRowInTree(state.data, action.payload.id, {
        status: "unknown",
      });
      const retriedQuiz = searchTree(retriedCourseData, action.payload.id);
      return {
        ...state,
        data: retriedCourseData,
        selectedSection: retriedQuiz,
      };
    default:
      return state;
  }
};
